/* Carousel */
$('.slideCarousel').carousel({
    "wrap" : true,
    "interval" : false
});

$(".carousel-inner").swiperight(function() {
    $(this).parent().carousel('prev');
});

$(".carousel-inner").swipeleft(function() {
    $(this).parent().carousel('next');
});
/**/
$(window).on('load', function(){

    $('.slideCarousel').each(function(index,value) {
        $(this).children('.carousel-inner').carouselHeights();
    });

    $('.carousel-inner').each(function (index, value) {
        if($(this).children(".item").length == 1){
            $(this).parent().children(".carousel-control").hide();
            $(this).parent().children(".carousel-indicators").hide();
        }else{
            $(this).children(".item").each(function(index) {
                var active;
                if(index > 0) {
                    active = "";
                }else{
                    active = "active";
                }

                var carousel = $(this).parent().parent().attr("id");

                $(this).parent().parent().children(".carousel-indicators").append("<li data-target='#"+carousel+"' data-slide-to='"+index+"' class='"+active+"'></li>");
            });
        }
    });

});
